(() => {
  if (window.PrithviyaBrandSections) return;

  const matchesBrand = (target, activeBrand) => target === 'both' || target === activeBrand;

  const getSectionRoots = (root) => {
    const sections = Array.from(root.querySelectorAll?.('[data-brand-section]') || []);
    if (root.matches?.('[data-brand-section]')) sections.unshift(root);
    return sections;
  };

  const refresh = (root = document) => {
    const activeBrand = document.documentElement.getAttribute('data-active-brand') || 'clothing';

    getSectionRoots(root).forEach((sectionRoot) => {
      const targets = Array.from(sectionRoot.querySelectorAll('[data-brand-target]'));
      const wrapper = sectionRoot.closest('.shopify-section');
      if (!wrapper) return;
      if (targets.length === 0) {
        wrapper.classList.remove('brand-section--empty');
        return;
      }

      const hasVisibleBlock = targets.some((element) =>
        matchesBrand(element.getAttribute('data-brand-target') || 'both', activeBrand)
      );
      wrapper.classList.toggle('brand-section--empty', !hasVisibleBlock);
    });
  };

  window.PrithviyaBrandSections = { refresh };

  document.addEventListener('DOMContentLoaded', () => refresh());
  document.addEventListener('prithviya:brand-change', () => refresh());
  document.addEventListener('shopify:section:load', (event) => refresh(event.target));
  document.addEventListener('shopify:block:select', (event) => {
    const block = event.target.closest?.('[data-brand-target]');
    const target = block?.getAttribute('data-brand-target');

    if ((target === 'clothing' || target === 'decor') && window.switchBrandCategory) {
      window.switchBrandCategory(target);
    }
    refresh();
  });

  new MutationObserver(() => refresh()).observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['data-active-brand'],
  });
})();
